<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Items</p>
        </template>
        <b-row>              
            <b-col cols="6" md="6">
                <div >
                    <b-button v-b-tooltip.hover title="Carga Masiva" variant="info" @click="$emit('open-massive-import-modal')" >
                        <b-icon icon="upload" ></b-icon>
                    </b-button>
                </div>
            </b-col>              
            <b-col cols="6" md="6">
                <div class="text-right">
                    <b-button variant="info" class="mr-2 text-white" :href="urlWebBackend+'download-items-empresa-csv/'+user.empresa_id" target="_blank">
                        Exportar Xls <b-icon icon="download"></b-icon>
                    </b-button>
                    <b-button variant="info" class="text-white" :to="{name: 'registerItemEmpresa'}">Registrar Nuevo</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="computedFields" 
                striped hover  
                :items="items">
                <template v-slot:cell(codigo)="{ item }">
                    <b-row>
                        <b-col class="col-sm-2 d-none d-sm-block">
                            <b-img :src="item.imagen" :alt="item.nombre" style="max-width: 100%; max-height: 100px; object-fit: scale-down;"></b-img>
                        </b-col>
                        <b-col cols="12" md="9">
                            <div>
                                {{ item.nombre }}
                            </div>
                            <div>
                                <b>Item:</b> {{ item.codigo }}
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <template v-slot:cell(categoria)="{ item }">
                    {{ item.categoria }}
                </template>
                <template v-slot:cell(existencia)="{ item }" v-if="opcionExistencia === 1">
                    {{ item.existencia }}
                </template>
                <template v-slot:cell(precio)="{ item }">
                    $ {{numberFormat(item.precio)}}
                </template>
                <template v-slot:cell(created_at)="{ item }">
                    {{ item.created_at }}
                </template>
                <template v-slot:cell(status)="{ item }">
                    <b-form-checkbox v-model="item.status" name="check-button" switch  @change="$emit('update-status-item', item)"  />
                </template>
                <template v-slot:cell(is_archived)="{ item }">
                    <b-form-checkbox v-model="item.is_archived" v-if="item.status != true" name="check-button" switch  @change="$emit('update-archived-item', item)"  />
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="info" v-b-tooltip.hover.right title="Editar" class="text-white" 
                    :to="{name: 'editItemEmpresa', params:{ id: item.id}}">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="items.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-card>
</template>

<script>

export default {
    name: "ItemsTable",
    props: {
        items: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        },
        urlWebBackend: {
            type: String
        },
        user: {
            type: Object
        },
        opcionExistencia: {
            type: Number
        }
    },
    computed: {
        computedFields() {
            if(this.opcionExistencia === 0)
                return this.fields.filter(field => !field.requiresPermission);
            else
                return this.fields;
        }
    },
    data(){
        return{
            fields: [
                { key: 'codigo', label: 'Item', sortable: true},
                { key: 'categoria', label: 'Categoria', sortable: true},
                { key: 'existencia', label: 'Cantidad Disponible', sortable: true, requiresPermission: true },
                { key: 'precio', label: 'Precio', sortable: true},
                { key: 'created_at', label: 'Fecha', sortable: true},
                { key: 'status', label: 'Estado', sortable: true},
                { key: 'is_archived', label: 'Archivar', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-items-list-empresa');
        },
        getInventoryListEmpresa(){
            this.$emit('get-items-list-empresa');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);            
        }
    }
};

</script>
<style scoped>

</style>